import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Paso6pagePage } from './paso6page.page';

const routes: Routes = [
  {
    path: '',
    component: Paso6pagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Paso6pagePageRoutingModule {}
